import React from 'react';
import { useNavigate } from 'react-router-dom';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import BrandWordmark from './BrandWordmark';
import PublicSiteFooter from './PublicSiteFooter';
import './InfoPages.css';

function Support({ theme = 'dark', toggleTheme }) {
  const navigate = useNavigate();
  const isDark = theme === 'dark';

  return (
    <div className={`info-page-shell ${isDark ? 'info-page-dark' : 'info-page-light'}`}>
      <div className="info-page-card">
        <div className="info-page-topbar">
          <div className="info-page-brand"><BrandWordmark className="info-page-brand-mark" /></div>
          <div className="info-page-topbar-actions">
            {toggleTheme ? (
              <button
                className="theme-toggle-btn info-page-theme-toggle"
                type="button"
                onClick={toggleTheme}
                aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
              >
                {isDark ? <LightModeOutlinedIcon fontSize="small" /> : <DarkModeOutlinedIcon fontSize="small" />}
              </button>
            ) : null}
            <button className="nav-primary-btn" type="button" onClick={() => navigate('/')}>
              Back to Home
            </button>
          </div>
        </div>

        <header className="info-page-header">
          <div className="info-page-badge">Help Center</div>
          <h1>Support</h1>
          <p>Quick guidance for product, technical, and compliance-related questions.</p>
        </header>

        <div className="info-page-body info-page-body-readable">
          <div className="info-page-lead-card">
            <div className="info-page-section-kicker">Fastest path to help</div>
            <h2>Share the details that unblock us quickly</h2>
            <p>
              Include your organization, browser, reproduction steps, and screenshots if available. That gives our team the
              fastest route from triage to resolution.
            </p>
          </div>

          <div className="info-page-grid">
            <section className="info-page-panel">
              <h3>Product Questions</h3>
              <p>Need help understanding upload, review, redaction tools, or export flow.</p>
            </section>
            <section className="info-page-panel">
              <h3>Technical Issues</h3>
              <p>Use this channel for login errors, upload failures, rendering issues, or browser-specific bugs.</p>
            </section>
            <section className="info-page-panel">
              <h3>Security &amp; Compliance</h3>
              <p>Ask about workflow expectations, deployment concerns, or data-handling guidance.</p>
            </section>
          </div>

          <section className="info-page-section">
            <h2>What to include</h2>
            <ul className="info-page-list">
              <li>Your browser and operating system</li>
              <li>The file type and approximate size</li>
              <li>Exact steps that caused the issue</li>
              <li>Screenshots or a short screen recording when possible</li>
            </ul>
          </section>

          <h2>Submit a Request</h2>
          <p>Email <strong>support@redacto.net</strong> with your organization, browser, reproduction steps, and screenshots if available.</p>
        </div>
      </div>
      <PublicSiteFooter />
    </div>
  );
}

export default Support;
